import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TarefaRoutingModule } from './tarefa-routing.module';
import { ListaComponent } from './pages/lista/lista.component';
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {FormsModule} from "@angular/forms";
import {NgxPaginationModule} from "ngx-pagination";


@NgModule({
    declarations: [
        ListaComponent
    ],
    exports: [
    ],
  imports: [
    CommonModule,
    TarefaRoutingModule,
    ComponentesModule,
    FormsModule,
    NgxPaginationModule
  ]
})
export class TarefaModule { }
